import HorizontalProgressBar from "./HorizontalProgressBar";
import styles from "./HorizontalProgressBarCount.module.css";

// Renders: [====bar====]  42
const HorizontalProgressBarCount = ({
  value,
  total,
  color,
  isLoading,
  label,
  onClick,
}) => {
  return (
    <div className={styles.wrapper}>
      <HorizontalProgressBar
        value={value}
        total={total}
        color={color}
        isLoading={isLoading}
      />
      {onClick ? (
        <button
          type="button"
          className={`${styles.count} ${styles.clickable}`}
          aria-label={`Filter by ${label} severity (${value} vulnerabilities)`}
          onClick={onClick}
        >
          {isLoading ? "" : value}
        </button>
      ) : (
        <span className={styles.count}>{isLoading ? "" : value}</span>
      )}
    </div>
  );
};

export default HorizontalProgressBarCount;
